import React from 'react';
import {useSelector} from 'react-redux';

import {apiCallInProgressSelector} from 'modules/api/selectors';

import Button from 'components/Controls/Button';
import Spinner from 'components/Controls/Spinner';

export default function CancelAndContinueButtons(props) {

    const {cancelAction, continueAction} = props;
    const apiCallInProgress = useSelector(apiCallInProgressSelector);

    const continueButton = continueAction
        ? <Button label="Continue" type="submit" action={() => continueAction()}/>
        : null;
    const cancelButton = cancelAction
        ? <Button label="Cancel" action={() => cancelAction()} variant="secondary"/>
        : null;

    const containerStyles = {
        display: 'flex',
        marginTop: 10,
    }

    return <div style={containerStyles}>
        {apiCallInProgress
            ? <Spinner />
            : <>{continueButton}{cancelButton}</>
        }
    </div>;

}